export default __webpack_public_path__ + "static/media/TooltipArrow.79e91037.svg";